/**
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *           _____                    _____                    _____
 *          /\    \                  /\    \                  /\    \
 *         /::\    \                /::\    \                /::\    \
 *        /::::\    \              /::::\    \               \:::\    \
 *       /::::::\    \            /::::::\    \               \:::\    \
 *      /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *     /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *    /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *   /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *  /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 * /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 * \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *  \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *   \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *    \:::\   \::::/    /              \::::/    /      \::::/____/
 *     \:::\  /:::/    /               /:::/    /        \:::\    \
 *      \:::\/:::/    /               /:::/    /          \:::\    \
 *       \::::::/    /               /:::/    /            \:::\    \
 *        \::::/    /               /:::/    /              \:::\____\
 *         \::/____/                \::/    /                \::/    /
 *          ~~                       \/____/                  \/____/
 */

import _ from "underscore";
import { push } from "connected-react-router";
import { call, put } from "redux-saga/effects";
import Toast from "../../utils/Toast";

/**
 * The request was made and the server responded with a status code
 * that falls out of the range of 2xx
 * @param error
 * @param action
 * @param ignoreToast
 * @param overrideErrorToastToInfo - To change error to info message
 */
function* httpErrorHelpers(
  error,
  action,
  ignoreToast = false,
  overrideErrorToastToInfo = false
) {
  if (error.response) {
    yield call(
      handleApiResponseError,
      error.response,
      error.message,
      ignoreToast,
      overrideErrorToastToInfo
    );
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
  }

  const status = error.response ? error.response.status : null;

  yield put(action(error.message, status));
}

/**
 * This function will handle error from the response
 * @param errResponse
 * @param errMessage
 * @param ignoreToast
 * @param overrideErrorToastToInfo - To change error to info message
 */
function* handleApiResponseError(
  errResponse,
  errMessage,
  ignoreToast,
  overrideErrorToastToInfo = false
) {
  const statusCode = errResponse.status;
  const { messages } = errResponse.data;

  if (statusCode === 401) {
    yield put(push("/auth/login"));
  }

  if (!_.isEmpty(messages) && !ignoreToast) {
    const { text, type } = messages[0];
    type === "error"
      ? !overrideErrorToastToInfo
        ? Toast.error(text)
        : Toast.info(text)
      : Toast.info(text);
  } else if (!_.isEmpty(errMessage) && !ignoreToast) {
    !overrideErrorToastToInfo
      ? Toast.error(errMessage)
      : Toast.info(errMessage);
  }
}

export default httpErrorHelpers;



// WEBPACK FOOTER //
// ./src/services/httpUtilities/httpErrorHelpers.js